import React from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import { useGetDevRankingQuery } from '@apis/mediacore/owner'
import { ElementHTML } from '@helpers/helper.rendering'
import { Link } from 'gatsby'

const FrequentSearch = (props: RealEstateDataPageComponentData) => {
  const {
    title,
    titleElement,
    paragraphElement,
    paragraph,
    global_data,
    backgroundColor,
    backgroundHexa,
  } = props
  const { divisionPath } = global_data

  const { data, isLoading } = useGetDevRankingQuery()

  return (
    data &&
    data?.length > 0 && (
      <section
        style={{ backgroundColor: backgroundHexa }}
        className={
          'fp-dev ' + (!isLoading && data?.length === 0 ? 'd-none' : '') + (' ' + backgroundColor)
        }
      >
        <Container fluid>
          <>
            <Row>
              <Col lg={2}>
                <ElementHTML
                  elementType={titleElement || 'h2'}
                  children={title || 'Búsquedas'}
                  className={'section-title pb-lg-5 mb-lg-4 mb-5 text-start'}
                />
              </Col>

              <Col lg={10}>
                <ElementHTML
                  elementType={paragraphElement || 'p'}
                  children={paragraph || ''}
                  className={'text-center text-lg-start'}
                />
              </Col>
            </Row>
            <Row className="text-center mx-auto px-0 px-lg-auto mt-lg-0 mt-4">
              <Col lg={{ span: 10, offset: 2 }}>
                <Row>
                  {data?.map((rank) => (
                    <Col
                      className="mt-lg-2 mt-5"
                      lg={4}
                    >
                      <h5>
                        {' '}
                        Emprendimientos en{' '}
                        {rank.label
                          ?.toLowerCase()
                          .split('en ')
                          .map((text) => text.charAt(0).toUpperCase() + text.slice(1))}
                      </h5>
                      {rank?.values?.map((dev) => (
                        <p style={{ fontStyle: 'inherit', fontSize: 'inherit' }}>
                          <Link
                            className="w-100 d-block"
                            to={
                              (divisionPath ?? '') +
                              '/emprendimiento/' +
                              dev?.name?.replaceAll(' ', '-')?.replaceAll('/', '-')?.toLowerCase() +
                              '/' +
                              dev!.id
                            }
                          >
                            Emprendimiento {dev?.name}
                          </Link>
                        </p>
                      ))}
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </>
        </Container>
      </section>
    )
  )
}

export default FrequentSearch
